import { Status } from "./Status";

export class RecallLineItemStatusSmartEnum {
    static ToPick = new Status("To Pick", 1, "pill--orange", "ToPick");
    static ToPack = new Status("To Pack", 2, "pill--blue", "ToPack");
    static Cancelled = new Status("Cancelled", 3, "pill--red");
    static Invalid = new Status("Not Found", 4, "pill--red", "Invalid"); // Even though the state is technically invalid, cellnass want it displaying as not found
    static Recalled = new Status("Recalled", 5, "pill--green");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "RecallLineItemStatusSmartEnum";
    }
}

